<template>
	<div>
		<iframe
			v-if="clicked"
			class="mx-auto max-w-full adjust-height"
			:src="url + '?muted=false&autostart=false&originalSize=false&startWithHD=false'"
			allowfullscreen="allowfullscreen"
			frameborder="0"
			allow="autoplay"
			:width="width"
			:height="height"
		></iframe>

		<div v-else
			 @click="clicked = true"
			 ref="cover"
			 class="bg-cover bg-center bg-blue-500/10 cursor-pointer flex items-center justify-center max-w-full mx-auto rounded-lg"
			 :style="coverStyle()">
			<div
				class="flex items-center justify-center w-16 h-16 p-3 bg-blue-500 text-white rounded-full transition-all duration-150 ease-in-out hover:scale-105">
				<svg-icon icon="hand-index" class="w-8 h-8"></svg-icon>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['url', 'width', 'height', 'cover'],
	data() {
		return {
			clicked: false,
			calcWidth: 0,
			calcHeight: 0,
		};
	},
	mounted() {
		let ratio = this.height / this.width;
		let actualWidth = this.$refs.cover.offsetWidth;

		if (actualWidth < this.width) {
			this.calcWidth = actualWidth;
			this.calcHeight = this.calcWidth * ratio;
		} else {
			this.calcWidth = this.width;
			this.calcHeight = this.height;
		}
	},
	methods: {
		coverStyle() {
			let styles = {
				backgroundImage: this.cover ? `url(${this.cover})` : null,
			};
			if (this.calcWidth) {
				styles.width = this.calcWidth + 'px';
				styles.height = this.calcHeight + 'px';
			}
			return styles;
		}
	}

}
</script>
